import { Translation } from '../../features/ui-config'
import i18n, { SupportedLanguage, fallbackLanguage } from '../i18n'

/**
 * Retrieves a translation from the config for the current selected language.
 *
 * @param {Translation} configTranslation - The config object with the translation like an label or placeholder.
 * @returns {string} The translated string, or an empty string if no translation is found.
 */
export function getConfigTranslation(configTranslation?: Translation): string {
  if (!configTranslation || Object.keys(configTranslation).length === 0) {
    return ''
  }

  const { language } = i18n

  return (
    configTranslation[language as SupportedLanguage] ||
    configTranslation[fallbackLanguage as SupportedLanguage] ||
    ''
  )
}
